import React from 'react';
import { notifyManageDeviceGroupPermissionDenied } from 'pages/private/components/notifications/permission-notification';
import { usePermissionContext } from './permission-provider';

const useDeviceGroupPermissionContext = () => {
    const { hasPermission, runHandler } = usePermissionContext();

    const { canManageDeviceGroup, canAssignDevices } = React.useMemo(() => {
        return {
            canManageDeviceGroup: hasPermission('Device Groups Modify'),
            canAssignDevices: hasPermission('Move Devices'),
        };
    }, [hasPermission]);

    return {
        hasPermission,
        runHandler: (
            permissionCode: 'Device Groups' | 'Move Devices',
            action: () => Promise<unknown>,
            onMissingPermission?: () => unknown,
        ): Promise<unknown> => {
            return runHandler(permissionCode, action, onMissingPermission ?? notifyManageDeviceGroupPermissionDenied);
        },
        canManageDeviceGroup,
        canAssignDevices,
    };
};
export { useDeviceGroupPermissionContext };